import client from "services/ngage/api-client";
import {Ticket, TicketData} from "types/Ticket";
import deserializeTicket from "services/ngage/deserializers/ticket";
import {parameters, queryString} from "services/string";
import DataResource from "../../types/DataResource";

type TicketFilters = {
    search?: string | null
    member?: number
    sort?: string | null
    page?: number
    perPage?: number
    holder?: number
    status?: string
}

/**
 * Get all tickets (paginated)
 */
const all = async ({member, page = 1, perPage = 100}: TicketFilters) => {
    const query = queryString({member, page, per_page: perPage})
    const response = await client.get<DataResource<Ticket> | null>(`/tickets?${query}`)

    if (response.data) {
        response.data.data = response.data.data.map(deserializeTicket)
    }

    return response.data
}

/**
 * Get all tickets that match the given filters (paginated)
 */
const filtered = async (filters: TicketFilters = {}) => {
    const params = parameters(filters, {page: 1, per_page: 1000});
    const response = await client.get<DataResource<Ticket> | null>('/tickets', {params});

    if (response.data) {
        response.data.data = response.data.data.map(deserializeTicket)
    }

    return response.data
}

/**
 * Get a single ticket
 *
 * @param {number} id
 */
const get = async (id: number) => {
    return deserializeTicket(
        (await client.get<Ticket>(`/tickets/${id}`)).data
    )
}

/**
 * Store a new ticket 
 *
 * @param data
 */
const store = async (data: TicketData) => {
    return deserializeTicket(
        (await client.post<Ticket>('/tickets', data)).data
    )
}

/**
 * Update an existing ticket 
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: TicketData) => {
    return deserializeTicket(
        (await client.put<Ticket>(`/tickets/${id}`, data)).data
    )
}

/**
 * Permanently delete a ticket
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    return (await client.delete<null>(`/tickets/${id}`)).status === 204
}

const tickets = {
    all,
    filtered,
    get,
    store,
    update,
    destroy
}

export default tickets;